/**
 * 出力ログページ用のスクリプト
 */

if (is_route('export_logs.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        export_logs_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.export_logs_event_set = function() {
    
    /*---- CSVダウンロード時 ----*/

    // CSVダウンロード時
    $(document).on('click', '#export_logs_search-form-action_download', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // 検索フォームを配列化
        let datas = $('#search-form').serializeArray();
        // ポスト送信を実行
        post(action, datas);
    });

}